module.exports = __webpack_public_path__ + "static/fourvill-page-e52bb1108b371cf4d1bbd2475722a578.mp4";